import { Component, Input } from '@angular/core';

type IconKind = 'actionable' | 'alert' | 'custom';

@Component({
  selector: 'hf-no-items-placeholder',
  templateUrl: './no-items-placeholder.component.html',
  styleUrls: ['./no-items-placeholder.component.scss']
})
export class NoItemsPlaceholderComponent {
  @Input() placeholderLabel!: string;
  @Input() iconKind!: IconKind;

  /** required if iconKind === 'custom' */
  @Input() customIconSrc?: string;

  constructor() {}

  public get iconSrc(): string {
    switch (this.iconKind) {
      case 'actionable':
        return '/assets/icons/svg/no-actionable-items-icon.svg';
      case 'alert':
        return '/assets/icons/svg/alert-icon.svg';
      case 'custom':
        return this.customIconSrc!;
      default:
        // Should be unreachable due to ngOnInit guards
        return '';
    }
  }
}
